import { Dialog, DialogTitle, DialogContent, IconButton, Typography, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CollaborationWorkspaceContent from './CollaborationWorkspaceContent';

const CollaborationWorkspaceModal = ({ open, onClose, collaborationData }) => {
  if (!collaborationData) return null;

  const { workspaceId, workspace, workspaceName } = collaborationData;

  const handleDetach = () => {
    const isElectron = typeof window !== 'undefined' && !!window.electronAPI;
    if (isElectron && window.electronAPI?.collaboration?.openWindow) {
      window.electronAPI.collaboration.openWindow({ workspaceId, workspaceName });
      if (onClose) onClose();
      return;
    }
    window.open(
      `/collaboration/${workspaceId}`,
      '_blank',
      'width=1280,height=820,noopener,noreferrer'
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      scroll="paper"
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
            Collaboration Workspace
          </Typography>
          {workspaceName && (
            <Typography variant="caption" color="text.secondary">
              {workspaceName}
            </Typography>
          )}
        </Box>
        <IconButton size="small" onClick={onClose} sx={{ ml: 1 }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        <CollaborationWorkspaceContent
          workspace={workspace}
          workspaceName={workspaceName}
          onDetach={handleDetach}
        />
      </DialogContent>
    </Dialog>
  );
};

export default CollaborationWorkspaceModal;
